module.exports = __webpack_public_path__ + "static/media/torsunov.1840e2ba.mp3";